import Image from 'next/image';
import React from 'react';
import ArrowButton, {
  ArrowDirection,
} from '@/components/navigation/ArrowButton';
import { CHAIN_ID } from '@/constants/constants';
import useNftMeta from '@/hooks/useNftMeta';
import type { BrandFragment } from '@/utilities/__generated__/graphql';
import { BucketType, createBucketURL } from '@/utilities/createBucketUrl';
import {
  getAlchemyNetwork,
  getOpenseaNetworkName,
} from '@/utilities/functions';
import { AvatarSize } from './Avatar';
import AvatarInfo from './AvatarInfo';
import { TitleVerifiedTheme } from './TitleVerified';

interface LicensedNftProps {
  collectionAddress?: string;
  tokenName: string;
  tokenId: string;
  dealName: string;
  brand: BrandFragment;
  dealId: number;
}

const LicensedNft = ({
  collectionAddress,
  tokenId,
  tokenName,
  brand,
  dealName,
  dealId,
}: LicensedNftProps) => {
  const network = getAlchemyNetwork(CHAIN_ID);
  const networkName = getOpenseaNetworkName(CHAIN_ID);
  const { nftThumbnail } = useNftMeta({
    collectionAddress: collectionAddress,
    tokenId: tokenId,
    network: network,
  });

  return (
    <>
      {nftThumbnail ? (
        <a
          href={`https://opensea.io/assets/${networkName}/${collectionAddress}/${tokenId}`}
          rel="noreferrer"
          target="_blank"
        >
          <div
            className={
              'relative h-[411px] w-[301px] overflow-hidden rounded-2xl hover:cursor-pointer md:w-full lg:h-[423px]'
            }
          >
            <div className="absolute inset-0">
              <Image
                unoptimized={true}
                src={nftThumbnail ?? ''}
                alt={`${tokenName} #${tokenId}`}
                layout="fill"
                objectFit="cover"
                className="rounded-lg"
              />
            </div>
            <div className="absolute inset-0 w-full max-w-[347px] rounded-lg bg-gradient-to-t from-primary-main" />
            <div className="absolute bottom-0 flex w-full items-center justify-between p-6">
              <div className="h-full w-full pr-3">
                <AvatarInfo
                  contentClasses="text-white font-regular text-sm"
                  theme={TitleVerifiedTheme.white}
                  size={AvatarSize.sm}
                  title={dealName}
                  primaryInfo={brand.company_name ?? ''}
                  secondaryInfo={`#${tokenId}`}
                  verified={false}
                  image={createBucketURL(
                    BucketType.Brand,
                    brand.username,
                    brand.updated_at
                  )}
                  textLink={`/deal/${dealId}`}
                />
              </div>
              <ArrowButton
                direction={ArrowDirection.right}
                classes="text-primary-main"
              />
            </div>
          </div>
        </a>
      ) : null}
    </>
  );
};

export default LicensedNft;
